// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-message-queue[data-v-6f76a5a4]{margin:20px 0;padding:0 15px;width:343px;height:63px;background:rgba(25,118,210,.26666666666666666);border-radius:9px;display:flex;justify-content:start;align-items:center}", ""]);
// Exports
module.exports = exports;
